import React from 'react';

import { Placement } from '@blueprintjs/popover2';

import MultiLineEllipsisText from './MultiLineEllipsisText';
import SingleLineEllipsisText from './SingleLineEllipsisText';

export interface EllipsisTextProps {
  text: string;
  className?: string;
  placement?: Placement;
  maxLineCount?: number;
}

const EllipsisText: React.FC<EllipsisTextProps> = ({ text, className, placement = 'top', maxLineCount = 1 }) => {
  const sharedProps = {
    text,
    className,
    placement
  };

  if (maxLineCount > 1) {
    return <MultiLineEllipsisText maxLineCount={maxLineCount} {...sharedProps} />;
  }
  return <SingleLineEllipsisText {...sharedProps} />;
};

export default React.memo(EllipsisText);
